import {
  FETCH_EVENTS,
  POST_EVENT,
  POST_SCHEDULE,
  PUT_SCHEDULE,
  PUBLISH_EVENT
} from '../actions/events';

const initialState = {
  fetching: true,
  data: [],
}

const schedules = (state = [], action) => {
  switch(action.type) {
    case `${PUT_SCHEDULE}_FULFILLED`:
      return state.map(s => s.id === action.payload.id ? { ...s, ...action.payload } : s)
    case `${POST_SCHEDULE}_FULFILLED`:
      return [ ...state, action.payload ];
    default:
      return state;
  }
}

const event = (state = {}, action) => {
  switch(action.type) {
    case `${PUBLISH_EVENT}_FULFILLED`:
      return { ...state, ...action.payload }
    case `${PUT_SCHEDULE}_FULFILLED`:
    case `${POST_SCHEDULE}_FULFILLED`:
      return {
        ...state,
        schedules: schedules(state.schedules, action),
      }
    default:
      return state;
  }
}

const events = (state = initialState, action) => {
  switch(action.type) {
    case `${PUT_SCHEDULE}_FULFILLED`:
    case `${POST_SCHEDULE}_FULFILLED`:
      return { ...state,
        data: state.data.map(e => {
          return e.id === action.eventId ? e : event(e, action);
        })
      };
    case `${PUBLISH_EVENT}_FULFILLED`:
      return { ...state, data: state.data.map(e => e.id === action.payload.id ? event(e, action) : e) }
    case `${FETCH_EVENTS}_PENDING`:
      return { ...initialState, fetching: true };
    case `${FETCH_EVENTS}_FULFILLED`:
      return { ...initialState, fetching: false, data: action.payload };
    case `${FETCH_EVENTS}_REJECTED`:
      return { ...initialState, fetching: false };
    case `${POST_EVENT}_FULFILLED`:
      return { ...state, data: [...state.data, action.payload] };
    default:
      return state;
  }
}

export default events;



// WEBPACK FOOTER //
// ./src/reducers/events.js